//removeIf(production)
import ClaroluzData from "../../../../../domain/entities/claroluz-data";
//removeIf(production)
import translation from "../../../../../../lang/es.json";
import ClaroluzContract from "./contract";
import ClaroluzDetail from "../detail/detail";
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
let claroluz_data = {plugin_url: ''};
//endRemoveIf(production)

class ClaroluzOffers {
    private data: ClaroluzData;

    constructor(data: ClaroluzData) {
        this.data = data;

        this.configure();
        this.clickEvent();
        this.show();
    }

    private configure() {
        let offers = this.data.offers;

        if (offers.length > 0) {
            let yearlySave = this.data.bill!.yearlySave;
            let yearlySaveText = document.querySelector('.claroluz-offers-yearly-save') as HTMLElement;
            yearlySaveText.innerHTML = translation.comparator.results.offers.title.replace('{yearlySave}', `<b class='yearly-save'>${ClaroluzValueFormat.of(yearlySave)}€</b>`);

            offers.forEach((offer, index) => {
                document.querySelector('.claroluz-offers-cards-container')?.appendChild(document.querySelector('#claroluz-template-card')!.children[0].cloneNode(true));
                let card = document.querySelector('.claroluz-offers-cards-container')!.children[index];
                let billValue = this.data.bill!.amount;
                let offerValue = offer.priceTotalWithVat;
                let percentage;

                card!.classList.add('card-item-' + index);
                this.setImage(card.querySelector('.claroluz-card-preview')!, offer.distributor);

                if (billValue > offerValue) {
                    percentage = (((billValue - offerValue) / billValue) * 100).toFixed(2);
                } else {
                    percentage = (((offerValue - billValue) / billValue) * 100).toFixed(2);

                    card.querySelector('.claroluz-card-band')?.classList.add('danger');
                    card.querySelector('.claroluz-current-value')?.classList.add('danger-color');
                }

                card.querySelector('.claroluz-card-band')!.innerHTML = translation.comparator.results.offers.card.bandText.replace('$1', ClaroluzValueFormat.of(percentage));
                card.querySelector('.claroluz-current-value')!.innerHTML = ClaroluzValueFormat.of(offerValue) + '€';
                card.querySelector('.claroluz-card-button-contract')!.setAttribute('data-id', index.toString());
                card.querySelector('.claroluz-card-button-link')!.setAttribute('data-id', index.toString());
                card.querySelector('.short-desc')!.innerHTML = offer.shortDescription;
                card.querySelector('.long-desc')!.innerHTML = offer.description;
            });
            
        } else {
            let containerNoOffers = document.querySelector('.claroluz-nooffers-container')!;
            // @ts-ignore
            containerNoOffers.querySelector('.no-offers-form-cups')!.value = this.data.bill!.cups;

            if (!this.data.bill!.topGas.hasTopGas && this.data.bill!.yearlySave > 0) {
                
                containerNoOffers.querySelector('.yearly-save')!.innerHTML = ClaroluzValueFormat.of(this.data.bill!.yearlySave) + '€/año';
                containerNoOffers.querySelector('.default-msg')!.classList.add('display-none');
                containerNoOffers.querySelector('.yearly-save-msg')!.classList.remove('display-none');
            } else {
                
                containerNoOffers.querySelector('.default-msg')!.classList.remove('display-none');
                containerNoOffers.querySelector('.yearly-save-msg')!.classList.add('display-none');
            }

            this.noOffers();
        }
    }

    private setImage(element: HTMLElement, company: string) {
        let image = element.querySelector('img')!;
        let imageSrc = claroluz_data.plugin_url + 'assets/img/';

        switch (company) {
            case 'iberdrola':
                imageSrc += 'iberdrola-logo.webp';
                break;
            case 'endesa':
                imageSrc += 'endesa-logo.webp';
                break;
            case 'plenitude':
                imageSrc += 'plenitude-logo.webp';
                break;
            case 'audax':
                imageSrc += 'audax-logo.webp';
                break;
            case 'nexus':
                imageSrc += 'nexus-logo.webp';
                break;
            case 'syder':
                imageSrc += 'syder-logo.webp';
                break;
            case 'aeq':
                imageSrc += 'aeq-logo.webp';
                break;
            case 'total':
                imageSrc += 'total-logo.webp';
                break;
            case 'gesternova':
                imageSrc += 'gesternova-logo.webp';
                break;
        
            default:
                if (company.indexOf('aldro') > -1) {
                    imageSrc += 'plenitude-logo.webp';
                } else {
                    imageSrc += 'light.svg';
                }                
                break;
        }

        image.setAttribute('src', imageSrc);
    }

    private clickEvent() {
        document.querySelectorAll('.claroluz-card-button-contract').forEach((button) => {
            button.addEventListener('click', () => {
                this.contract(parseInt(button.getAttribute('data-id')!));

                new ClaroluzEvents(appProperties(), 'comparator', 'contract', 'click');
            });
        });

        document.querySelectorAll('.claroluz-card-button-link').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                this.detail(parseInt(button.getAttribute('data-id')!));

                new ClaroluzEvents(appProperties(), 'comparator', 'detail', 'click');
            });
        });
    }

    private contract(id: number) {
        let offer = this.data.offers[id];
        new ClaroluzContract(this.data.bill!.cups, offer);
    }

    private detail(id: number) {
        let offer = this.data.offers[id];
        new ClaroluzDetail(this.data.bill!.cups, id, offer);

        new ClaroluzEventDispatch('claroluz_Detail_show');
    }

    private show() {
        document.querySelector('.claroluz-offers-container')?.classList.remove('display-none');
        document.querySelector('.claroluz-nooffers-container')?.classList.add('display-none');
    }

    private noOffers() {
        document.querySelector('.claroluz-offers-container')?.classList.add('display-none');
        document.querySelector('.claroluz-nooffers-container')?.classList.remove('display-none');
    }
}

//removeIf(production)
export default ClaroluzOffers;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)